import { render, staticRenderFns } from "./galleryAlbum.vue?vue&type=template&id=4894420b&scoped=true&"
import script from "./galleryAlbum.vue?vue&type=script&lang=js&"
export * from "./galleryAlbum.vue?vue&type=script&lang=js&"
import style0 from "./galleryAlbum.vue?vue&type=style&index=0&id=4894420b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894420b",
  null
  
)

export default component.exports